import styled from 'styled-components';
import { Box } from '@mui/material';

export const Header = styled(Box)`
  padding: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const ShortcutsRow = styled(Box)`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ActionsBar = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
`;
